import { useCallback } from 'react';

import { fetchEndpointData } from 'api';
import { publicEnvConfig } from 'config/public';
import { CONSENT_COOKIE_NAME } from 'constants/cookies';
import { useUserContext } from 'contexts';
import { getConsentGroupsByName } from 'utils/consent';
import { getCookie } from 'utils/cookies';
import { ignorePromiseRejection } from 'utils/helpers';

const LAST_CONSENT_UPDATE_KEY = 'lastConsentUpdate';

async function sendConsentUpdate() {
	const date = new Date();
	date.setFullYear(date.getFullYear() + 1);
	const validTo = date.toISOString().split('T')[0];

	const groups = getConsentGroupsByName(getCookie(CONSENT_COOKIE_NAME));
	await fetchEndpointData({
		name: 'PostConsent',
		body: {
			analytics: groups.analytics,
			marketing: groups.marketing,
			social: groups.social,
			validTo,
		},
	});
	globalThis.localStorage.setItem(
		LAST_CONSENT_UPDATE_KEY,
		Date.now().toString(),
	);
}

export function useUpdateConsent() {
	const userInfo = useUserContext();
	const isClubUser = userInfo?.customerType === 'Club';
	const shouldSendUpdate = publicEnvConfig.SEND_CONSENT_REQUEST === 'true';

	const forceUpdateConsent = useCallback(() => {
		if (isClubUser && shouldSendUpdate) {
			ignorePromiseRejection(sendConsentUpdate());
		}
	}, [isClubUser, shouldSendUpdate]);

	const updateConsent = useCallback(() => {
		const lastConsentUpdate = new Date(
			Number(globalThis.localStorage.getItem(LAST_CONSENT_UPDATE_KEY) || '0'),
		);
		const lastConsentUpdatePlus6Months = lastConsentUpdate.setMonth(
			lastConsentUpdate.getMonth() + 6,
		);

		if (Date.now() > lastConsentUpdatePlus6Months) {
			forceUpdateConsent();
		}
	}, [forceUpdateConsent]);

	return { updateConsent, forceUpdateConsent };
}
